var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRightarrowSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12.32 22.27 5.442-6.35-5.442-6.348a1 1 0 0 1 1.519-1.302l5.72 6.675a1.5 1.5 0 0 1 0 1.952l-5.72 6.675a1 1 0 0 1-1.519-1.302"
})));
export default SvgRightarrowSmall;